<template>
  <button
    type="button"
    class="btn box text-gray-700 disabled:opacity-50 flex items-center"
    @click="link"
  >
    <PrinterIcon class="w-4 h-4 mr-2 hidden md:block" />
    {{ props.title }}
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'btn-printer-multi',
  props: {
    title: {
      type: String,
      default: () => 'พิมพ์'
    },
    module: {
      type: String,
      required: true
    },
    queryString: {
      type: [String],
      default: () => null
    }
  },
  setup(props) {
    const link = () => {
      // console.log('props:', props.queryString)
      for (const q of props.queryString) {
        window.open(
          `${process.env.VUE_APP_API_PRINT}/pdf/${props.module}/print${q}`
        )
      }
    }
    return { props, link }
  }
})
</script>

<style scoped></style>
